<template>
  <div class="beacon-notification-list-container">
    <!--
    <el-row style="margin-bottom: 10px" v-if="enableTransfer">
      <el-button plain @click="transData">轉換JSON</el-button>
      <el-button plain @click="submitTransData">提交JSON</el-button>
    </el-row>
    -->
    <el-row>
      <div class="tfam-table-search">
        <span class="ti-search"></span>
        <input class="form-control" aria-describedby="addon-right addon-left" placeholder="搜尋">
      </div>
    </el-row>
    <el-row>
      <el-table
        :data="beaconMessageList"
        :show-header="false"
        :row-style="rowStyle"
        empty-text="無資料"
        v-loading="listLoading"
        style="width: 100%;">
        <el-table-column
          prop="title"
          label="識別名稱"
          width="180">
          <template slot-scope="scope">
            <span class="message-title" @click="goBeaconMessage(scope.row['beacon_message_id'])">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="內容"
          min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row | contentFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="狀態"
          width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.status ? '啟用' : '未啟用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="events"
          label="events">
          <template slot-scope="scope">
            <div
              class="beacon-events"
              :class="{ active: scope.row['beacons'] && scope.row['beacons'].length > 0 }"
              @click="handleBindingBeacon(scope.row)">
              <span class="tfam-link">{{ scope.row['beacons'] | filterBeaconNames }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
    <el-dialog
      title="選擇iBeacon"
      :visible.sync="beaconDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true">
      <beacon-select
        :binding-data="beaconMessageData"
        binding-type="beaconMessage"
        @update="finishBeaconBinding"></beacon-select>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchBeaconMessageList } from "../../api/beaconMessage";
  import BeaconSelect from "../Componments/BeaconSelect";

  export default {
    name: "BeaconNotificationList",
    components: {
      BeaconSelect
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    data() {
      return {
        beaconMessageList: [],
        beaconMessageData: undefined,
        beaconDialogVisible: false,
        listLoading: false
      }
    },
    filters: {
      contentFilter: function (row) {
        const filter = row['beaconMessageLangs'].filter(x => x['language_key'] === 'ZH_TW');
        if (filter.length > 0) {
          return filter[0]['content'] ? filter[0]['content'] : '-'
        } else {
          return '-'
        }
      },
      filterBeaconNames: function (beacons) {
        if (beacons && beacons.length > 0) {
          const names = [];
          for (const i in beacons) {
            names.push(beacons[i]['title'])
          }
          return names.join('，')
        } else {
          return '未綁定'
        }
      }
    },
    mounted() {
      this.getMessages()
    },
    methods: {
      finishBeaconBinding(val) {
        this.beaconDialogVisible = false;
        this.beaconMessageData = undefined;
        if (val['reload']) {
          this.getMessages()
        }
      },
      handleBindingBeacon(row) {
        this.beaconMessageData = JSON.parse(JSON.stringify(row));
        this.beaconDialogVisible = true;
      },
      getMessages() {
        const filter = {
          include: ['beaconMessageLangs', 'beacons']
        };
        this.listLoading = true;
        fetchBeaconMessageList(filter).then(response => {
          this.listLoading = false;
          this.beaconMessageList = response.data;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      goBeaconMessage(id) {
        this.$router.push({
          path: '/notification/beacon/' + id
        })
      },
      createNew() {
        this.goBeaconMessage('new')
      }
    }
  }
</script>

<style lang="scss">
  .message-title {
    cursor: pointer;
  }
  .introduction-max-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
</style>
